import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglemybusinessComponent } from './simple-icons-googlemybusiness.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglemybusinessComponent ],
    exports:      [ SimpleIconsGooglemybusinessComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglemybusinessModule {}
